import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import ShipmentList from './ShipmentList'

const ShipmentInfos = ({ shipments }) => {
    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Shipment ID</TableCell>
                        <TableCell>ETD</TableCell>
                        <TableCell>ETA</TableCell>
                        <TableCell>Shipped Qty</TableCell>
                        <TableCell>Received Qty</TableCell>
                        <TableCell style={{ width: '50px' }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {shipments?.map((shipment) => (
                        <ShipmentList shipment={shipment} key={shipment.id} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default ShipmentInfos
